import 'react-toastify/dist/ReactToastify.css';

import App from './src/App';
export const wrapRootElement = App;
